import { render, staticRenderFns } from "./PdfViewer.vue?vue&type=template&id=5e20b52c&scoped=true&"
import script from "./PdfViewer.vue?vue&type=script&lang=ts&"
export * from "./PdfViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e20b52c",
  null
  
)

export default component.exports